import { Drawer } from '@srcDS/js/components/molecules/drawer/Drawer';
import styles from './MobileFilterDrawer.module.scss';
import { ReactComponent as ChevronLeft } from '@srcDS/icons/tailwind-icons/icon-panel-arrow.svg';
import { ReactComponent as CloseCross } from '@srcDS/icons/tailwind-icons/icon-panel-cross.svg';

import { Text } from '@srcDS/js/components/typography/text/Text';
import Button from '@srcDS/js/components/atoms/button';
import FilterMenu from './FilterMenu';
import { useFilter } from '@srcDS/js/tastic/pages/category/hooks/useFilter';
import { FilterTag } from '@srcDS/js/components/molecules/filterTag/FilterTag';

export const MobileFilterDrawer = ({
  facets,
  activeFilter,
  drawerShown,
  setDrawerShown,
  setActiveFilter,
  filterTagsData,
  callback,
}) => {
  const { handleClearAllFacets, handleSubmitFaceChange, setFilterDisplayValues, isAnySelected } = useFilter();

  const onClose = () => {
    setDrawerShown(false);
  };

  const onGoBack = () => {
    if (activeFilter) {
      setActiveFilter(null);
      return;
    }
    onClose();
  };

  return (
    // @ts-ignore
    <Drawer
      position="left"
      customClasses={{
        content: styles.drawerContent,
        aside: styles.drawerSide,
        drawer: styles.drawer,
        isMobileDevice: styles.isMobileDevice,
      }}
      shown={drawerShown}
      showHeader={false}
    >
      <div className={styles.drawerContent}>
        {/** HEADER */}

        <div className={styles.mobileHeader}>
          {/* @ts-ignore */}
          <Button className={styles.headerBackButton} as="text" onClick={onGoBack}>
            <ChevronLeft className={styles.icon} width="30px" height="30px" />
          </Button>
          <Text as="span" className={styles.headerText} textTransform={'uppercase'}>
            FILTERS
          </Text>
          {/* @ts-ignore */}
          <Button className={styles.headerCloseButton} as="text" onClick={onClose}>
            <CloseCross className={styles.icon} width="30px" height="30px" />
          </Button>
        </div>
        <FilterMenu facets={facets} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />

        {/** BUTTONS AND TAGS */}

        <div className={styles.buttonsAndTagsContainer}>
          {filterTagsData?.length > 0 && (
            <div className={styles.filterTagWrapper}>
              <FilterTag onClick={onClose} filters={filterTagsData} showClearAll={false} />
            </div>
          )}
          <div className={styles.buttonsContainer}>
            {/* @ts-ignore */}
            <Button
              variant="primaryOutlined"
              customClasses={{
                button: styles.filterButton,
              }}
              onClick={() => {
                handleClearAllFacets();
                onClose();
              }}
              // disabled={Object.keys(localFilters).length === 0 && !rangeFilter?.selected}
            >
              Clear Filters
            </Button>

            {activeFilter && (
              /* @ts-ignore */
              <Button
                variant="primary"
                customClasses={{
                  button: styles.filterButton,
                }}
                disabled={!isAnySelected && activeFilter.type !== 'range'}
                onClick={() => {
                  handleSubmitFaceChange({
                    callback: () => {
                      setFilterDisplayValues((values) => ({
                        ...values,
                        filterShown: false,
                      }));
                    },
                  });
                  setActiveFilter(null);
                  callback();
                }}
              >
                <span>Apply Filters </span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
};
